<template>
  <div class="banner-details" v-if="_banner">
    <div class="title">
      <v-row no-gutters justify="space-between" align="start" class="flex-nowrap">
        <div class="headline font-weight-bold" @click="reloadItems">
          {{ _banner.company.name }}
        </div>
        <div class="subtitle-1 flex-grow-1 mx-4 align-self-end">
          <!-- {{ _banner.description }} -->
        </div>
        <router-link :to="{ name: 'home' }" class="back">
          <img src="@/assets/images/back_arrow.png" alt />back
        </router-link>
      </v-row>
    </div>
    <!-- <div class="content"> -->
    <div class="text-content">
      <div class="links">
        <a :href="link.url" v-for="link in _banner.links.filter((l) => l.active && l.name && l.name.trim())"
          :key="link._id" v-text="link.name" target="_blank" class="custom-link"></a>
        <!-- </div> -->
      </div>
    </div>
    <div class="formats-container" :fit-width="fitWidth" v-resize="onResize" :style="fitWidth ? 'margin:0 auto' : ''">
      <v-col cols="auto" class="banner-img stamp" v-show="_banner.thumb || _banner.liveUrl">
        <Rendered :banner="_banner" :watermark="_banner.company.panelStatus"
          :watermarkText="_banner.company.panelStatusText" @loaded="reloadItems" />
      </v-col>
      <v-col cols="auto" class="banner-img" v-for="formats in otherFormats" :key="formats._id">
        <Rendered :banner="formats" @loaded="reloadItems" :watermark="_banner.company.panelStatus"
          :watermarkText="_banner.company.panelStatusText" />
      </v-col>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Masonry from 'masonry-layout';

export default {
  name: "ClientBannerShow",
  components: {
    Rendered: () => import("@/components/Dashboard/BanerIframeRenderer"),
  },
  data() {
    return {
      fitWidth: false,
      msnry: null
    };
  },
  mounted() {
    this.msnry = new Masonry('.formats-container', {
      // options
      itemSelector: '.banner-img',
      gutter: 24,
      horizontalOrder: true,
      transitionDuration: '0.2s'
    });
  },
  props: {
    //   bannerID: {
    //     type: String,
    //     default() {
    //       return this.$route.params.id;
    //     },
    //   },
  },
  methods: {
    reloadItems() {
      console.log('xx')
      this.msnry.reloadItems();
      this.msnry.layout();
    },
    previewUrl(url) {
      return `${process.env.VUE_APP_BASE_URL}/preview?url=${decodeURIComponent(
        url
      )}`;
    },
    onResize() {
      this.fitWidth = window.innerWidth < 1080;
    },
    redraw() {
      // console.log('redrawq',w)
      // this.$redrawVueMasonry(this._banner.hash  );
    },
    sortBySize(a, b) {
      const bandA = a.dimensions
        .split("x")
        .reduce(function (previousValue, currentValue) {
          return previousValue * currentValue;
        });
      const bandB = b.dimensions
        .split("x")
        .reduce(function (previousValue, currentValue) {
          return previousValue * currentValue;
        });
      if (bandA < bandB) {
        return -1;
      }
      if (bandA > bandB) {
        return 1;
      }
      return 0;
    },
  },
  computed: {
    ...mapState(["banner"]),
    _banner() {
      const banner = this.banner.banners.find(
        (banner) => banner._id === this.$route.params.id
      );
      return banner;
    },
    otherFormats() {
      return this._banner.otherFormats
        .filter((of) => of.active)
        .sort(this.sortBySize);
    },
  },
};
</script>
<style lang="scss" scoped>
.banner-details {
  margin: -245px auto 0;
  max-width: 1100px;
  flex: 1;
}

.title {
  display: flex;
  justify-content: space-between;
  width: auto;
  align-items: center;
  margin: 0;
  font-style: normal;
  position: relative;
  margin-bottom: 77px;

  .headline {
    position: relative;
    display: flex;
    align-items: center;

    &:after {
      content: "";
      //   position: absolute;
      //   top: 50%;
      //   left: 100%;
      background-color: #ef3f37;
      height: 2px;
      width: 170px;
      margin-left: 30px;
    }
  }
}

.formats-container {

  // margin: 0 -1em;
  .banner-img {
    position: absolute;
    margin-bottom: 2em;
    line-height: 0;
    position: relative;

    .size {
      position: absolute;
      top: -1em;
      left: 0;
    }
  }
}

.custom-link {
  width: 230px;
  height: 50px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ef3f37;
  color: #ef3f37 !important;
  text-decoration: none;
  font-size: 20px;
  font-weight: 600;
  margin: 0 10px 10px 0;
  transition-property: border-color, color;
  transition-duration: 200ms;

  &:hover {
    background-color: rgba(239, 64, 55, 0.06);
    // color: #c1263e;
    // border-color: #c1263e;
  }
}

.back {
  font-size: 20px;
  color: #ef3f37 !important;
  font-weight: bold;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;

  img {
    margin: 0 12px;
  }
}

// .content {
//   display: flex;
.text-content {
  margin: 0 0 48px;
  position: relative;
  // }
}

img,
.live-preview {
  //   width: 300px;
  //   height: 600px;
  display: inline-block;
}

@media only screen and (max-width: 1200px) {
  .title {
    margin-left: 0;
    padding-bottom: 13px;
    margin-bottom: 23px;

    &:before {
      background-color: #ef3f37;
      height: 4px;
      width: 300px;
    }

    h2 {
      font-size: 30px;
    }
  }

  .back {
    transform: translateY(-50px);
  }
}

@media only screen and (max-width: 800px) {
  .banner-details {
    padding: 40px 0;
    margin: 0;
  }

  .back {
    font-size: 0.8em;

    img {
      margin: 0 12px;
      width: 3em;
    }
  }

  .content {
    flex-direction: column;

    .description {
      margin: 50px 0;
      font-size: 24px;
      min-height: auto;
    }

    .text-content {
      margin: 0;
    }

    .links {
      display: flex;
      flex-direction: column;

      .custom-link {
        margin-bottom: 22px;
      }
    }
  }
}

@media (min-width: 1780) {
  .search {
    margin: auto 26px 80px;
  }
}

@media only screen and (max-width: 1780px) {
  .banner-details {
    margin: -20px auto 0;
  }
}
</style>
